import { usePage } from "@/components/page/PageContext";
import { Card } from "@/pages/data/DataChart";
import { useTerminal } from "@/pages/data/terminal/terminal-utils";
import {
  ChartIntlVsDomestic,
  TrafficChart,
} from "@/pages/data/terminal/TerminalCharts";
import { useReportContext } from "@/stores/ReportContext";
import { useEffect } from "react";

export function PassengerFlowPage() {
  const terminal = useTerminal();
  const { reportId } = useReportContext();

  const { setTitles } = usePage();

  useEffect(() => {
    setTitles(["Passenger Flow"]);
  }, []);

  return (
    <div className={"w-full grid grid-cols-1 md:grid-cols-4 gap-4"}>
      <div className="md:col-span-2">
        <ChartIntlVsDomestic
          query={{
            terminal_id: terminal.id,
            direction: "dep",
            measure: "pax",
            type: "terminal",
            group: "terminal",
          }}
          title={
            "Departing Passenger Flow Comparison International vs Domestic"
          }
        />
      </div>
      <div className="md:col-span-2">
        <ChartIntlVsDomestic
          query={{
            terminal_id: terminal.id,
            direction: "arr",
            measure: "pax",
            type: "terminal",
            group: "terminal",
          }}
          title={"Arriving Passenger Flow Comparison International vs Domestic"}
        />
      </div>
      <div className="md:col-span-3">
        <Card title={"Connecting Passenger Count"}>
          <div className="space-y-4">
            <TrafficChart
              query={{
                terminal_id: terminal.id,
                measure: "pax",
                type: "terminal",
                pax_type: "connecting",
              }}
            />
          </div>
        </Card>
      </div>
    </div>
  );
}
